module.exports = __webpack_public_path__ + "img/xia003.a57b703c.png";